import { Tag, Space, Tooltip } from 'antd';
import { displayNumbers } from '../../../../variables/numbersFunctions';

export const statistiquesGlobalesColumns = () => [
    {
        title: 'Exercice',
        dataIndex: 'exercice',
        key: 'exercice',
        width: 100,
        fixed: 'left',
        sorter: (a, b) => a.exercice - b.exercice,
    },
    {
        title: 'Mois',
        dataIndex: 'mois',
        key: 'mois',
        width: 80,
        render: (mois) => {
            if (!mois) return '-';
            const moisNames = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
                'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];
            return moisNames[mois - 1];
        }
    },
    {
        title: 'Organisme',
        dataIndex: 'organismeNom',
        key: 'organismeNom',
        width: 180,
        fixed: 'left',
        ellipsis: true,
    },
    {
        title: 'Agence',
        dataIndex: 'agenceNom',
        key: 'agenceNom',
        width: 150,
        ellipsis: true,
    },
    {
        title: 'Catégorie',
        dataIndex: 'categorieNom',
        key: 'categorieNom',
        width: 120,
        render: (text, record) => (
            <Tag color="blue">{record.categorieCode}</Tag>
        )
    },
    {
        title: 'Contrats',
        dataIndex: 'nombreContrats',
        key: 'nombreContrats',
        width: 100,
        align: 'center',
        sorter: (a, b) => a.nombreContrats - b.nombreContrats,
    },
    {
        title: 'Assurés',
        dataIndex: 'nombreAssures',
        key: 'nombreAssures',
        width: 100,
        align: 'center',
    },
    {
        title: 'Émissions',
        children: [
            {
                title: 'Nombre',
                dataIndex: 'nombreEmissions',
                key: 'nombreEmissions',
                width: 90,
                align: 'center',
                render: (val) => <Tag color="green">{val || 0}</Tag>
            },
            {
                title: 'Montant',
                dataIndex: 'montantEmissions',
                key: 'montantEmissions',
                width: 130,
                align: 'right',
                render: (val) => (
                    <span style={{ color: '#52c41a', fontWeight: 500 }}>
                        {displayNumbers(val)} F
                    </span>
                ),
                sorter: (a, b) => a.montantEmissions - b.montantEmissions,
            },
            {
                title: 'Prime Nette',
                dataIndex: 'primeNetteEmissions',
                key: 'primeNetteEmissions',
                width: 130,
                align: 'right',
                render: (val) => `${displayNumbers(val)} F`
            },
        ]
    },
    {
        title: 'Annulations',
        children: [
            {
                title: 'Nombre',
                dataIndex: 'nombreAnnulations',
                key: 'nombreAnnulations',
                width: 90,
                align: 'center',
                render: (val) => <Tag color="red">{val || 0}</Tag>
            },
            {
                title: 'Montant',
                dataIndex: 'montantAnnulations',
                key: 'montantAnnulations',
                width: 130,
                align: 'right',
                render: (val) => (
                    <span style={{ color: '#ff4d4f', fontWeight: 500 }}>
                        {displayNumbers(val)} F
                    </span>
                ),
                sorter: (a, b) => a.montantAnnulations - b.montantAnnulations,
            },
            {
                title: 'Prime Nette',
                dataIndex: 'primeNetteAnnulations',
                key: 'primeNetteAnnulations',
                width: 130,
                align: 'right',
                render: (val) => `${displayNumbers(val)} F`
            },
        ]
    },
    {
        title: 'Production Nette',
        children: [
            {
                title: 'Montant Net',
                dataIndex: 'montantNet',
                key: 'montantNet',
                width: 150,
                align: 'right',
                render: (val) => (
                    <span style={{
                        color: val >= 0 ? '#1890ff' : '#ff4d4f',
                        fontWeight: 700,
                        fontSize: '14px'
                    }}>
                        {displayNumbers(val)} F
                    </span>
                ),
                sorter: (a, b) => a.montantNet - b.montantNet,
            },
            {
                title: 'Prime Nette',
                dataIndex: 'primeNetteNet',
                key: 'primeNetteNet',
                width: 130,
                align: 'right',
                render: (val) => (
                    <span style={{ fontWeight: 600 }}>
                        {displayNumbers(val)} F
                    </span>
                )
            },
        ]
    },
];

export const detailContratsColumns = () => [
    {
        title: 'N° Police',
        dataIndex: 'numeroPolice',
        key: 'numeroPolice',
        width: 150,
        fixed: 'left',
        ellipsis: true,
    },
    {
        title: 'Assuré',
        dataIndex: 'assureNom',
        key: 'assureNom',
        width: 200,
        ellipsis: true,
    },
    {
        title: 'Date Effet',
        dataIndex: 'dateEffet',
        key: 'dateEffet',
        width: 110,
        render: (date) => date ? new Date(date).toLocaleDateString('fr-FR') : '-'
    },
    {
        title: 'Organisme',
        dataIndex: 'organismeNom',
        key: 'organismeNom',
        width: 180,
        ellipsis: true,
    },
    {
        title: 'Agence',
        dataIndex: 'agenceNom',
        key: 'agenceNom',
        width: 150,
        ellipsis: true,
    },
    {
        title: 'Catégorie',
        dataIndex: 'categorieCode',
        key: 'categorieCode',
        width: 100,
        render: (text) => <Tag color="blue">{text}</Tag>
    },
    {
        title: 'Producteur',
        dataIndex: 'producteurNom',
        key: 'producteurNom',
        width: 180,
        ellipsis: true,
    },
    {
        title: 'Émissions',
        children: [
            {
                title: 'Nombre',
                dataIndex: 'nombreEmissions',
                key: 'nombreEmissions',
                width: 80,
                align: 'center',
                render: (val) => <Tag color="green">{val || 0}</Tag>
            },
            {
                title: 'Montant',
                dataIndex: 'montantEmission',
                key: 'montantEmission',
                width: 130,
                align: 'right',
                render: (val) => (
                    <span style={{ color: '#52c41a', fontWeight: 500 }}>
                        {displayNumbers(val)} F
                    </span>
                )
            },
        ]
    },
    {
        title: 'Annulations',
        children: [
            {
                title: 'Nombre',
                dataIndex: 'nombreAnnulations',
                key: 'nombreAnnulations',
                width: 80,
                align: 'center',
                render: (val) => <Tag color="red">{val || 0}</Tag>
            },
            {
                title: 'Montant',
                dataIndex: 'montantAnnulation',
                key: 'montantAnnulation',
                width: 130,
                align: 'right',
                render: (val) => (
                    <span style={{ color: '#ff4d4f', fontWeight: 500 }}>
                        {displayNumbers(val)} F
                    </span>
                )
            },
        ]
    },
    {
        title: 'Montant Net',
        dataIndex: 'montantNet',
        key: 'montantNet',
        width: 150,
        align: 'right',
        fixed: 'right',
        render: (val) => (
            <span style={{
                color: val >= 0 ? '#1890ff' : '#ff4d4f',
                fontWeight: 700,
                fontSize: '14px'
            }}>
                {displayNumbers(val)} F
            </span>
        ),
        sorter: (a, b) => a.montantNet - b.montantNet,
    },
];